// extracted by mini-css-extract-plugin
module.exports = {"Ondemand":"style_Ondemand__20qCz","hr":"style_hr__vxP8O"};